<div class="qpx-refetch">
    @if (isRefetching()) {
        <qpx-loader
            [ariaLabelledBy]="ariaLabelledBy()"
            size="sm"
            context="secondary"
            tone="muted"
            containerClass=""
        />
    }
</div>

<ng-content />

<output
    class="sr-only"
    aria-live="polite"
    [attr.aria-label]="ariaLabelledBy() ? null : 'Pagination status'"
    [attr.aria-labelledby]="ariaLabelledBy() || null"
>
    {{ announcedStatus() }}
</output>

@if (viewMode() !== undefined) {
    <mat-button-toggle-group
        class="qpx-pagination-view-mode-toggle sm"
        [(ngModel)]="viewMode"
        [ngModelOptions]="{ standalone: true }"
        [disabled]="disabled()"
        aria-label="View mode"
        hideSingleSelectionIndicator="true"
    >
        <mat-button-toggle value="list" disableRipple="true">
            <ng-icon qpx size="sm" name="lucideList" />
            <span class="sr-only">List view</span>
        </mat-button-toggle>
        <mat-button-toggle value="grid" disableRipple="true">
            <ng-icon qpx size="sm" name="lucideLayoutGrid" />
            <span class="sr-only">Grid view</span>
        </mat-button-toggle>
    </mat-button-toggle-group>
}

@if (showPagination()) {
    <nav
        #paginationNavigation
        class="navigation"
        tabindex="-1"
        data-qpx-content-width-focus-fallback
        [attr.aria-label]="ariaLabelledBy() ? null : 'Pagination'"
        [attr.aria-labelledby]="ariaLabelledBy() || null"
    >
        <button
            qpxButton
            [matButton]="appearance()"
            context="secondary"
            size="sm"
            class="icon-only boundary-page"
            [style.display]="boundaryDisplay()"
            data-qpx-content-width-sensitive
            aria-label="First page"
            qpxTooltip="First page"
            [disabled]="disabled() || !pagination().canGoPrevious"
            (click)="requestPage(1)"
        >
            <ng-icon qpx size="sm" name="lucideArrowLeftToLine" matButtonIcon />
        </button>

        <button
            qpxButton
            [matButton]="appearance()"
            context="secondary"
            size="sm"
            class="icon-only"
            aria-label="Previous page"
            qpxTooltip="Previous page"
            #previousPageButton
            [disabled]="disabled() || !pagination().canGoPrevious"
            (click)="requestPreviousPage()"
        >
            <ng-icon qpx size="sm" name="lucideChevronLeft" matButtonIcon />
        </button>

        <button
            qpxButton
            [matButton]="appearance()"
            context="secondary"
            size="sm"
            class="icon-only"
            aria-label="Next page"
            qpxTooltip="Next page"
            #nextPageButton
            [disabled]="disabled() || !pagination().canGoNext"
            (click)="requestPage(pagination().currentPage + 1)"
        >
            <ng-icon qpx size="sm" name="lucideChevronRight" matButtonIcon />
        </button>

        <button
            qpxButton
            [matButton]="appearance()"
            context="secondary"
            size="sm"
            class="icon-only boundary-page"
            [style.display]="boundaryDisplay()"
            data-qpx-content-width-sensitive
            aria-label="Last page"
            qpxTooltip="Last page"
            [disabled]="disabled() || !pagination().canGoNext"
            (click)="requestPage(pagination().totalPages)"
        >
            <ng-icon
                qpx
                size="sm"
                name="lucideArrowRightToLine"
                matButtonIcon
            />
        </button>
    </nav>
}
